import React from 'react';
import classNames from 'classnames';

import '../index.scss';
import seta from '../../../../assets/images/select_laranja.svg';

const menuOptions = [
  { title: 'Blocos Padrões', value: 'defaultItems', enabled: true },
  { title: 'Blocos Avançados', value: 'advancedItems', enabled: true },
  { title: 'Integrações', value: 'integrationItems', enabled: true },
];

const MenuItem = ({ item, openSecondary }) => (
  <li className="builder__context__menu-item">
    <a
      className={classNames({
        disabled: !item.enabled,
      })}
      onMouseEnter={(e) => openSecondary(e, item)}
      href="#/"
      onClick={(e) => e.preventDefault()}
    >
      {item.icon ? (
        <img src={`/assets/images/icons/builder/${item.icon}.png`} alt="" />
      ) : null}
      <span>
        {item.title}
        <img src={seta} className="img-item-title-menu" alt="" />
      </span>
    </a>
  </li>
);

const MenuItems = ({ items, openSecondary }) =>
  items.map((item) => (
    <MenuItem
      openSecondary={openSecondary}
      item={item}
      key={String(item.value)}
    />
  ));

export default ({ style, openSecondary }) => {
  return (
    <div className="builder__context" style={{ ...style }}>
      <div className="builder__context--position">
        <div className="builder__context__arrow" />
        <ul className="builder__context__items">
          <p className="title-bloco-items">Selecione o bloco</p>
          <MenuItems openSecondary={openSecondary} items={menuOptions} />
        </ul>
      </div>
    </div>
  );
};
